var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM6.99883 1.16637C3.77717 1.16637 1.16549 3.77805 1.16549 6.99971C1.16549 10.2214 3.77717 12.833 6.99883 12.833C10.2205 12.833 12.8322 10.2214 12.8322 6.99971C12.8322 3.77805 10.2205 1.16637 6.99883 1.16637Z",
    fill: "#FBCBAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00046 2.33374C4.42367 2.33437 2.33496 4.42347 2.33496 7.00041C2.33496 9.57734 4.42367 11.6664 7.00046 11.6671V2.33374Z",
    fill: "#FBCBAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/inProgressIcon.2c8c4a1615b51148dd009d11f7bc365a.svg";
export { ForwardRef as ReactComponent };